import { doPostRequest } from '@/tools/axios_';
import { usePublicOrPrivate } from '@/tools/orgPropertiesHooks';
import { Utils } from '@/tools/utils';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Affix, Button, Collapse, Modal, Popover } from 'antd';
import { useRef, useState } from 'react';
import ProductContextWrap from '../../productSys/components/ProductContextWrap';
import { TableHeaderFlex } from '../../productSys/components/tablesTemplate';
import ContinueRateInfoPolicyList from '../../productSys/newProduct/component/continue-rate-info-list';
import arrowDown from '../img/arrow-icon.png';
import over from '../img/check_success.png';
import './index.less';
const { Panel } = Collapse;

// 推广费-弹窗底部的确认和取消按钮（设计统一样式）
const ProductLaunch = (props = {}) => {
    const scrollRef = useRef();
    const [readStatus,setReadStatus] = useState(false);
    const [fromType, setFromType]  = useState('4');
    const publicOrPrivate = usePublicOrPrivate();// 对公对私
    // 对滚动区域进行验证
    const handleOnScroll=()=> {
        const contentScrollTop = scrollRef.current?.scrollTop || 0; // 滚动条距离顶部
        const clientHeight = scrollRef.current.clientHeight; // 可视区域
        const scrollHeight = scrollRef.current.scrollHeight; // 滚动条内容的总高度
        if ((contentScrollTop + clientHeight) >= (scrollHeight - 150)) {
            console.log('滑到底部了')
            if(readStatus !==2){
                setReadStatus(true);
                setTimeout(() => {
                    setReadStatus(2);
                }, 500);
            }

        }
    }
    const onSaveHandel = async() => {
        let signingSpuList=[];
        if(props.productList.length>0) {
            props.productList.forEach((item)=>{
                let obj={};
                obj.spuId = item.spuId;
                obj.continueRateId = item?.continueRateRule?.continueRateId;
                obj.commissionInfoId = item?.rateDetail?.commissionInfoId;
                signingSpuList.push(obj);
            });
        }
        const { status } = await doPostRequest({
            url: '/api/cls/company/product/confirmUnSigningSpu',
            data: {
                orgId: Utils.getOrgId(),
                "signingSpuList": signingSpuList
            }
        });
        if(status===200){
            props.onSuccess();
        }
    }
    const {
        visible = false,
        onCancel
    } = props;
    return <div>
        <Modal
           title="产品上架通知"
            open={visible}
            closable={false}
            style={{ top: 40 }}
            width={980}
            footer={null}
            wrapClassName="productLaunch"
        >
            <div class="product_launch_detail_div">
                <Affix offsetTop={0}>
                    <p style={{marginBottom:'15px'}}>您好，已为您上线以下<em>{props.productList.length}款</em>新产品</p>
                </Affix>
                <div  class="generateDialog_productList"  ref={scrollRef} onScrollCapture={() => handleOnScroll()}>
                    {
                        props.productList && props.productList.map((item)=>
                            <Collapse collapsible="icon" defaultActiveKey={['1']}>
                                <Panel className="productListItem" header={item.rateDetail?.spuName+' ('+item.rateDetail?.spuId+ ')'} key="1">
                                    <div  className='cardBox'>
                                        {
                                            publicOrPrivate ===2?<span className='desc'>该产品推广费、继续率、补偿金等具体规则如下，系统未约定的内容，按照贵我双方签署协议的约定执行，请您仔细阅读：</span>:<span className='desc'>根据贵我双方签订的《保险业务合作协议》/《推广服务协议》及相关补充协议的约定，该产品推广费，继续率，补偿金等具体规则如下，请您仔细阅读：</span>
                                        }
                                        <div className="cardTitle">推广费</div>
                                        <div className="cardSubTitle" style={{'font-size': '14px'}}>推广费费率表（%）</div>

                                        <div className='table_div template-table-wrap' style={{width:'900px'}}>
                                        <div className="edit-theader">
                                            <TableHeaderFlex hasActive={false}
                                                productType={item.rateDetail?.productType || '1000'}
                                                productState = {2}
                                                isFromRepository={fromType === '4'}
                                                isShortInsClass={false} // 短险变更为固定5年；原需判断：state.productType === '2000'
                                            />
                                            </div>
                                            <div className={`table-body bordered`}>
                                                <ProductContextWrap
                                                    isEdit={false}
                                                    hasActive={false}
                                                    data={{
                                                        productType: item.rateDetail?.productType || '1000',
                                                        ...item,
                                                    }}
                                                    isFromRepository={fromType === '4'}
                                                    isShortInsClass={false} // 短险变更为固定5年；原需判断：state.productType === '2000'
                                                />
                                            </div>
                                        </div>
                                        {item.continueRateRule?.cycles &&  <><div  className="cardSubTitle" style={{'font-size':'14px','marginTop':'10px'}}>续期推广费要求</div><ContinueRateInfoPolicyList configFlag={item.configFlag} cycles={item.continueRateRule.cycles} paymentMethod={publicOrPrivate}></ContinueRateInfoPolicyList></>}
                                    </div>
                                </Panel>
                            </Collapse>
                        )
                    }
                    {publicOrPrivate ===2? <div className='exportText' style={{marginTop: '30px', color: 'orange'}}>
                        注：<br/>
                        1、贵方阅读上述内容后,如果点击"同意"即视为贵方已经理解上述全部内容的具体含义并接受相关条款约束,上述内容与贵我双方签订的协议具有同等法律效力。<br/>
                        2、贵方确认:如我司需对推广费支付/退还规则进行补充或调整,将在系统中公示,贵方在线阅读系统中公示的规则并继续提供推广服务的,即视为认可并接受相关条款约束,同时我司在对账单中与贵方确认。<br/>
                        3、继续率说明：<br/>
                        R13、R25、R37、R49以固化继续率<Popover placement="bottomLeft"
                                content={<p style={{width: 400}}>固化继续率：投保人应续保费之日后的第3个月的15日当日，我司确定R13，R25，R37的继续率。如投保人应续保费之日为2024年4月10日，则我司在2024年7月15日确定R13，R25，R37的继续率</p>}
                                arrowPointAtCenter
                            >
                        <div className='mark' style={{display:'inline-block','color': '#FF7736'}}>?</div></Popover>为准。<br/>
                    </div>:<div className='exportText' style={{ marginTop: '30px', color: 'orange'}}>
                        注：<br/>
                        1、R13、R25、R37、R49以固化继续率<Popover placement="bottomLeft"
                                content={<p style={{width: 400}}>固化继续率：投保人应续保费之日后的第3个月的15日当日，我司确定R13，R25，R37的继续率。如投保人应续保费之日为2024年4月10日，则我司在2024年7月15日确定R13，R25，R37的继续率</p>}
                                arrowPointAtCenter
                            >
                        <div className='mark' style={{display:'inline-block','color': '#FF7736'}}>?</div></Popover>为准。<br/>
                        2、续期继续率统计方法：考核对象为贵方和我公司签署协议时注册的商户。若同一个商户下有不同的多个子商户或下级商户，根据签约时注册的商户计算继续率。<br/>
                        3、续期继续率计算方法：按产品名称计算继续率，若一个产品有多个关联的产品ID，继续率合并计算。如：A产品-尊享版和A产品-典藏版，系统中展示为两款产品，尊享版和典藏版合并计算续期继续率。<br/>
                        4、推广费费率可能会出现延迟的情况，即贵司推广的产品承保在前，推广费费率展示在后，此种情况，请出单前和我司沟通确认推广费费率，如贵司推广产品已承保，则默认已知晓推广费费率。<br/>
                        5、贵方确认:如我司需对推广费支付/退还规则进行补充或调整,将在系统中公示,贵方在线阅读系统中公示的规则并继续提供推广服务的,即视为认可并接受相关条款约束,同时我司在对账单中与贵方确认。<br/>
                        6、贵方阅读上述内容后,如果点击"同意"即视为贵方已经理解上述全部内容的具体含义并接受相关条款约束,上述内容与贵我双方签订的协议具有同等法律效力。<br/>
                    </div>}
                </div>
                <div className={` ${readStatus===2 ? 'disappearAn' : ''} ${'tips'}`}>
                    {
                        <div className="warpBox">
                            <img src ={!readStatus ?  arrowDown : over }/>
                            <span>{!readStatus ? '请划动到底，阅读完整内容' : '恭喜！此文件阅读完成' }</span>
                        </div>
                    }
                </div>

                <div className="generateDialog_bottom">
                    <Button onClick={() => {
                         Modal.confirm({
                            icon: <InfoCircleOutlined color='#1890ff' />,
                            title: '重要提示',
                            width: 600,
                            content:  (<div><p>为了使您充分了解产品规则，<em style={{color:'red', fontStyle: 'normal'}}>请仔细阅读并确认</em>。若您未确认产品规则，可能会<em style={{color:'red',  fontStyle: 'normal'}}>影响后续结算</em></p><p>您还要继续吗？</p></div>),
                            okText: '继续',
                            cancelText: "返回",
                            onOk: () => {
                                onCancel && onCancel()
                            },
                            onCancel: () => { }
                        })
                    }}>取消</Button>
                    <Button type="primary" style={{marginLeft:'20px'}} disabled={!readStatus} onClick={() => {
                        onSaveHandel()
                    }}>确认以上所有产品约定</Button>
                </div>
            </div>

        </Modal>
    </div>;
};


export default ProductLaunch;
